import React from 'react';
import { grey } from '@mui/material/colors';
import { InputField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { DeleteOutline, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

import { StagesFormValues } from '../../../../types';

interface Props {
  isEdit: boolean;
  rowIndex: number;
  onRemove: VoidFunction;
  onMoveRow: (from: number, to: number) => void;
}

export const TitleCell = ({ rowIndex, onRemove, onMoveRow, isEdit }: Props) => {
  const { control } = useFormContext<ListingForm<StagesFormValues>>();
  const rows = useWatch({ control, name: 'bodyFields' });

  return (
    <Stack direction="row" gap="0.5rem" width="100%" alignItems="center">
      <Box
        sx={{
          borderRadius: '100%',
          padding: '0.25rem 0.75rem',
          backgroundColor: grey[200],
        }}
      >
        <Typography variant="caption">{rowIndex + 1}</Typography>
      </Box>

      <InputField
        control={control}
        name={`bodyFields.${rowIndex}.name`}
        inputProps={{ variant: 'outlined', placeholder: 'Enter stage name', required: true }}
      />

      {!isEdit && (
        <Stack direction="row" alignItems="center">
          <Tooltip title="Remove configuration">
            <IconButton size="small" color="error" onClick={onRemove}>
              <DeleteOutline />
            </IconButton>
          </Tooltip>

          <Tooltip title="Move row down">
            <IconButton
              size="small"
              disabled={rowIndex + 1 > rows.length - 1}
              onClick={() => {
                onMoveRow(rowIndex, rowIndex + 1);
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          </Tooltip>

          <Tooltip title="Move row up">
            <IconButton
              size="small"
              disabled={!rowIndex}
              onClick={() => {
                onMoveRow(rowIndex, rowIndex - 1);
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
          </Tooltip>
        </Stack>
      )}
    </Stack>
  );
};
